'use client';

import { useTranslations } from 'next-intl';
import { SettingsDangerSection } from '../../settings/SettingsDangerSection';

export type ApplicationDangerSectionProps = {
  applicationName: string;
  onDelete: () => void | Promise<void>;
  isDeleting?: boolean;
};

export function ApplicationDangerSection({
  applicationName,
  onDelete,
  isDeleting,
}: ApplicationDangerSectionProps) {
  const t = useTranslations('designSystem.applicationSettings.danger');
  const tCommon = useTranslations('designSystem.common');

  return (
    <SettingsDangerSection
      rowLabel={t('deleteApplication')}
      actionLabel={t('deleteApplication')}
      warningTitle={t('warningTitle')}
      warningDescription={t('warningDescription')}
      confirmTitle={t('dialogTitle', { appName: applicationName })}
      confirmDescription={t('deleteConfirmation', { appName: applicationName })}
      confirmText={tCommon('delete')}
      cancelText={tCommon('cancel')}
      onAction={onDelete}
      loading={isDeleting}
    />
  );
}
